import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from '../authentication/auth.service';
import { map } from 'rxjs/operators';

import { Personnel } from './personnel';
import { PersonnelDetail } from './personnel-detail';
import { Occupation } from './occupation';
import { AppGlobals } from '../../app.globals';
import * as moment from 'moment'

@Injectable()
export class PersonnelService {

    constructor(private http: HttpClient, private authService: AuthService) { }

    getPersonnel(periode = ""): any {
        var searchParams = "";
        if (periode != "") {
            let dateDebut = moment(periode+'/01',"MM/YYYY/DD");
            let dateFin = moment(dateDebut).add(1, 'month').add(-1, 'days');
            searchParams = `?datedebut=${moment(dateDebut).format('YYYYMMDD')}&datefin=${moment(dateFin).format('YYYYMMDD')}`;
        };
        return this.http.get<any>('/api/Personnel/PersonnelSecretariat'+searchParams)
            .pipe(map(personnel => {
                personnel = personnel.Personnel;
                for (var i = 0; i < personnel.length; i++) {
                    personnel[i].Libelle = `${personnel[i].Nom} ${personnel[i].Prenom} (${personnel[i].Reference})`;
                    personnel[i].DateVerifAgenda = personnel[i].DateVerifAgenda != null ? moment(personnel[i].DateVerifAgenda,"YYYYMMDD").toDate() : null;
                }

                return personnel;
            }));
    }

    getPersonnelByCle(cle: number): any {
        return this.http.get<any>('/api/Personnel/PersonnelSecretariat/'+cle)
            .pipe(map(personnel => {
                personnel = personnel.Personnel;
                personnel.DateVerifAgenda = personnel.DateVerifAgenda != null ? moment(personnel.DateVerifAgenda,"YYYYMMDD").toDate() : null;
                return personnel;
            }));
    }

    verifierAgenda(clePerso: number, periode: string): any {
       let params = { DateVerifAgenda: moment(moment(periode+'/01',"MM/YYYY/DD")).add(1, 'month').add(-1, 'days').format('YYYYMMDD') }
        return this.http.put<any>(`/api/Personnel/Signaletique/${clePerso}`, params)
            .pipe(map(personnel => {
                personnel.DateVerifAgenda = personnel.DateVerifAgenda != null ? moment(personnel.DateVerifAgenda,"YYYYMMDD").toDate() : null;
                return personnel;
            }));

    }

    getOccupations(clePerso: number, periode: string): any {
        let dateDebut = moment(periode+'/01',"MM/YYYY/DD");
        let dateFin = moment(dateDebut).add(1, 'month').add(-1, 'days');
        return this.http.get<any>(`/api/Personnel/Occupations?clepersonnel=${clePerso}&datedebut=${moment(dateDebut).format('YYYYMMDD')}&datefin=${moment(dateFin).format('YYYYMMDD')}`)
            .pipe(map(occupations => {
                occupations = occupations.Occupations;
                for (let occup of occupations) {
                    occup.Libelle = this.getOccupationLib(occup);
                  }
                return occupations;
            }));
    }

  getOccupationLib(occup: Occupation) : string {
    let numSec = AppGlobals.variantToStr(occup.PersonnelNumeroSecretariat);
    if (numSec != "" && AppGlobals.variantToStr(occup.PeriodeOccupationNumeroSecretariat)+AppGlobals.variantToStr(occup.NumeroSecretariat) != "")
      numSec += "|";
    numSec += AppGlobals.variantToStr(occup.PeriodeOccupationNumeroSecretariat);
    if (numSec != "" && AppGlobals.variantToStr(occup.PeriodeOccupationNumeroSecretariat)+AppGlobals.variantToStr(occup.NumeroSecretariat) != "")
      numSec += "|";
    numSec += AppGlobals.variantToStr(occup.NumeroSecretariat);

    let periode = occup.DateFin != null ? `${moment(occup.DateDebut,"YYYYMMDD").format('DD/MM/YYYY')} -> ${moment(occup.DateFin,"YYYYMMDD").format('DD/MM/YYYY')}` : `${moment(occup.DateDebut,"YYYYMMDD").format('DD/MM/YYYY')} -> ...`;
    let qs = `${occup.NbHrsSemaine.toFixed(2)}/${occup.NbHrsRefSemaine.toFixed(2)}/${occup.NbJrsSemaine.toFixed(2)}`;

    return `${numSec}     ${periode}    ${qs}`;
  }
}
